<div class="d-flex flex-column playbook-name-column align-items-start">
    <span class="fw-bold playbook-name">{{ dataItem[columnOptions.field] }}</span>
    <span class="mt-50 playbook-description"><small>{{ dataItem['purpose'] }}</small></span>
</div>